import React, { useState } from "react";
import {
  FaBalanceScale,
  FaHandshake,
  FaGavel,
  FaShieldAlt,
} from "react-icons/fa";
import courtroomBg from "../../assets/images/Herosection/herobanner.jpg";

const C = {
  deepRed: "#A10F1A",
  gold: "#C79A3B",
  cream: "#F3EEE4",
  darkGold: "#8C6A24",
  richBrown: "#5A3A1A",
  black: "#1A1A1A",
  bgLight: "#FAF7F2",
  white: "#FFFFFF",
};
const pillars = [
  {
    title: "Trusted Legal Guidance",
    desc: "Providing clear  and practical legal advice for every case. Tailored solutions to meet each client's unique needs. Focused on achieving the best possible legal outcomes.",
    icon: FaBalanceScale,
    stat: "24*7",
    statLabel: "Availability & Legal Support",
  },
  {
    title: "Client-First Approach",
    desc: "Every client receives personalized attention  and dedicated support. We maintain complete transparency throughout the legal process. Committed to achieving the best possible outcome for every case.",
    icon: FaHandshake,
    stat: "100%",
    statLabel: "Client Focus",
  },
  {
    title: "Strategic Litigation",
    desc: "Combining legal expertise with extensive courtroom experience. Developing strong  and practical strategies for every case. Dedicated to protecting client rights  and interests effectively.",
    icon: FaShieldAlt,
    stat: "98%",
    statLabel: "Success Rate",
  },
  {
    title: "Comprehensive Legal Services",
    desc: "Providing expert legal assistance across diverse practice areas. From civil  and criminal matters to corporate  and property disputes. Delivering complete legal solutions under one roof.",
    icon: FaGavel,
    stat: "1000+",
    statLabel: "Cases Won",
  },
];

const WhyChooseUs = () => {
  const [activeIdx, setActiveIdx] = useState(null);

  return (
    <section className="wcu-section">
      {/* ══ RESPONSIVE STYLES ══ */}
      <style>{`
        .wcu-section {
          width: 100%;
          background: ${C.bgLight};
          font-family: 'Georgia', 'Times New Roman', serif;
          overflow: hidden;
          box-sizing: border-box;
        }
        .wcu-top-strip {
          background: ${C.deepRed};
          padding: 0.85rem 1.5rem;
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .wcu-layout {
          display: grid;
          grid-template-columns: 1fr;
        }
        .wcu-image-panel {
          position: relative;
          overflow: hidden;
          min-height: auto;
        }
        .wcu-content-wrapper {
          position: relative;
          z-index: 2;
          padding: 3rem 1.5rem;
          height: 100%;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .wcu-stats-grid {
          display: grid;
          grid-template-columns: 1fr;
          margin-top: 2.5rem;
          border: 1px solid rgba(199,154,59,0.25);
          border-radius: 4px;
          overflow: hidden;
        }
        .wcu-stat-item {
          padding: 1.25rem 1.5rem;
          background: rgba(199,154,59,0.06);
          border-bottom: 1px solid rgba(199,154,59,0.2);
        }
        .wcu-stat-item:last-child {
          border-bottom: none;
        }
        .wcu-accordion-panel {
          background: ${C.white};
          border-top: 4px solid ${C.deepRed};
          display: flex;
          flex-direction: column;
        }
        .wcu-accordion-header {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 1.2rem 1.5rem;
        }
        .wcu-accordion-desc {
          padding: 0 1.5rem 1.5rem 4.5rem;
        }
        .wcu-cta-bar {
          padding: 1.5rem;
          background: ${C.deepRed};
          border-top: 3px solid ${C.gold};
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 16px;
        }
        .wcu-trust-bar {
          background: ${C.black};
          padding: 1.5rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
        }
        .wcu-trust-item {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        .wcu-trust-divider {
          display: none;
        }

        /* Tablet & Desktop Adjustments */
        @media (min-width: 600px) {
          .wcu-stats-grid {
            grid-template-columns: 1fr 1fr;
          }
          .wcu-stat-item:nth-child(odd) {
            border-right: 1px solid rgba(199,154,59,0.2);
          }
          .wcu-stat-item:nth-child(1), .wcu-stat-item:nth-child(2) {
            border-bottom: 1px solid rgba(199,154,59,0.2);
          }
          .wcu-stat-item:nth-child(3), .wcu-stat-item:nth-child(4) {
            border-bottom: none;
          }
          .wcu-cta-bar {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
          }
          .wcu-trust-bar {
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            gap: 2rem;
          }
          .wcu-trust-divider {
            display: block;
            width: 1px;
            height: 14px;
            background: rgba(199,154,59,0.3);
          }
        }

        @media (min-width: 992px) {
          .wcu-top-strip {
            padding: 0.85rem 4rem;
          }
          .wcu-layout {
            grid-template-columns: 1fr 1fr;
          }
          .wcu-image-panel {
            min-height: 520px;
          }
          .wcu-content-wrapper {
            padding: 3.5rem 3rem;
          }
          .wcu-accordion-panel {
            border-top: none;
            border-left: 4px solid ${C.deepRed};
          }
          .wcu-accordion-header {
            padding: 1.6rem 2.5rem;
          }
          .wcu-accordion-desc {
            padding: 0 2.5rem 1.6rem 5.5rem;
          }
          .wcu-cta-bar {
            padding: 1.6rem 2.5rem;
          }
          .wcu-trust-bar {
            padding: 1.1rem 4rem;
            gap: 2.5rem;
          }
        }
      `}</style>

      {/* ══ TOP LABEL STRIP ══ */}
      <div className="wcu-top-strip">
        <div
          style={{ height: 1, width: 32, background: "rgba(199,154,59,0.6)" }}
        />
        <span
          style={{
            fontSize: 10,
            fontWeight: 700,
            color: C.gold,
            letterSpacing: "0.45em",
            textTransform: "uppercase",
            fontFamily: "sans-serif",
          }}
        >
          Why Choose R &amp; P Law Team
        </span>
      </div>

      {/* ══ MAIN SPLIT LAYOUT ══ */}
      <div className="wcu-layout">
        {/* ── LEFT: Image panel ── */}
        <div className="wcu-image-panel">
          <img
            src={courtroomBg}
            alt="R & P Law"
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: "grayscale(60%) brightness(0.4)",
            }}
          />
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(120deg, rgba(161,15,26,0.88) 0%, rgba(26,10,10,0.65) 100%)",
            }}
          />

          <div className="wcu-content-wrapper">
            {/* Top content */}
            <div>
              {/* Badge */}
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 10,
                  background: "rgba(199,154,59,0.12)",
                  border: "1px solid rgba(199,154,59,0.35)",
                  borderRadius: 2,
                  padding: "6px 16px",
                  marginBottom: "1.75rem",
                }}
              >
                <div
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: C.gold,
                  }}
                />
                <span
                  style={{
                    fontSize: 10,
                    color: C.gold,
                    fontFamily: "sans-serif",
                    letterSpacing: "0.3em",
                    textTransform: "uppercase",
                    fontWeight: 700,
                  }}
                >
                  Trusted Legal Counsel
                </span>
              </div>

              <h2
                style={{
                  fontSize: "clamp(26px, 3.5vw, 44px)",
                  fontWeight: 700,
                  color: C.cream,
                  margin: "0 0 1.25rem",
                  lineHeight: 1.2,
                }}
              >
                Why Clients <br />
                <span
                  style={{
                    color: C.gold,
                    fontStyle: "italic",
                    fontWeight: 400,
                  }}
                >
                  Choose Us
                </span>
              </h2>

              <p
                style={{
                  fontSize: 14,
                  color: "rgba(243,238,228,0.7)",
                  lineHeight: 1.9,
                  margin: 0,
                  fontFamily: "sans-serif",
                  fontWeight: 300,
                  maxWidth: 380,
                }}
              >
                We combine deep legal expertise with genuine commitment to
                client success ensuring every matter is h andled with strategic
                precision  and personal care.
              </p>
            </div>

            {/* Stats grid */}
            <div className="wcu-stats-grid">
              {pillars.map((p, i) => (
                <div key={i} className="wcu-stat-item">
                  <p
                    style={{
                      fontSize: 26,
                      fontWeight: 700,
                      color: C.gold,
                      margin: 0,
                      lineHeight: 1,
                      fontFamily: "'Georgia', serif",
                    }}
                  >
                    {p.stat}
                  </p>
                  <p
                    style={{
                      fontSize: 10,
                      color: "rgba(243,238,228,0.5)",
                      margin: "5px 0 0",
                      fontFamily: "sans-serif",
                      letterSpacing: "0.18em",
                      textTransform: "uppercase",
                    }}
                  >
                    {p.statLabel}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── RIGHT: Accordion panel ── */}
        <div className="wcu-accordion-panel">
          {/* Accordion items */}
          <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            {pillars.map((item, idx) => {
              const Icon = item.icon;
              const isActive = activeIdx === idx;
              const isLast = idx === pillars.length - 1;

              return (
                <div
                  key={idx}
                  onMouseEnter={() => setActiveIdx(idx)}
                  onMouseLeave={() => setActiveIdx(null)}
                  style={{
                    padding: "0",
                    borderBottom: isLast
                      ? "none"
                      : `1px solid rgba(140,106,36,0.14)`,
                    background: isActive ? "#FDF8F0" : C.white,
                    transition: "background 0.35s ease",
                    cursor: "default",
                  }}
                >
                  {/* Always-visible header row */}
                  <div className="wcu-accordion-header">
                    {/* Icon circle */}
                    <div
                      style={{
                        width: 46,
                        height: 46,
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        background: isActive
                          ? C.deepRed
                          : "rgba(161,15,26,0.07)",
                        border: `1.5px solid ${isActive ? C.deepRed : "rgba(161,15,26,0.18)"}`,
                        color: isActive ? C.white : C.deepRed,
                        fontSize: 18,
                        transition: "all 0.35s ease",
                      }}
                    >
                      <Icon />
                    </div>

                    {/* Title always visible */}
                    <h4
                      style={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: isActive ? C.deepRed : C.black,
                        margin: 0,
                        flex: 1,
                        fontFamily: "'Georgia', serif",
                        transition: "color 0.35s ease",
                      }}
                    >
                      {item.title}
                    </h4>

                    {/* Number */}
                    <span
                      style={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: isActive ? C.gold : "rgba(140,106,36,0.3)",
                        fontFamily: "sans-serif",
                        transition: "color 0.35s ease",
                        flexShrink: 0,
                      }}
                    >
                      0{idx + 1}
                    </span>
                  </div>

                  {/* Description exp ands on hover */}
                  {isActive && (
                    <div className="wcu-accordion-desc">
                      <div
                        style={{
                          width: 28,
                          height: 2,
                          background: C.gold,
                          borderRadius: 2,
                          marginBottom: "0.75rem",
                        }}
                      />
                      <p
                        style={{
                          fontSize: 14,
                          color: C.richBrown,
                          lineHeight: 1.85,
                          margin: 0,
                          fontFamily: "sans-serif",
                        }}
                      >
                        {item.desc}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* CTA bar at bottom of right panel */}
          <div className="wcu-cta-bar">
            <div>
              <p
                style={{
                  fontSize: 15,
                  fontWeight: 700,
                  color: C.cream,
                  margin: "0 0 3px",
                  fontFamily: "'Georgia', serif",
                }}
              >
                Ready to protect your rights?
              </p>
              <p
                style={{
                  fontSize: 11,
                  color: "rgba(243,238,228,0.55)",
                  margin: 0,
                  fontFamily: "sans-serif",
                  letterSpacing: "0.05em",
                }}
              >
                Free initial consultation available
              </p>
            </div>
            <a
              href="/contact-us"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "12px 26px",
                background: C.gold,
                color: C.black,
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: "0.22em",
                textTransform: "uppercase",
                fontFamily: "sans-serif",
                textDecoration: "none",
                borderRadius: 3,
                flexShrink: 0,
                whiteSpace: "nowrap",
                transition: "background 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = C.darkGold)
              }
              onMouseLeave={(e) => (e.currentTarget.style.background = C.gold)}
            >
              Consult Now →
            </a>
          </div>
        </div>
      </div>

      {/* ══ BOTTOM TRUST BAR ══ */}
      <div className="wcu-trust-bar">
        {[
          "Supreme Court of India",
          "Various HighCourt",
          "Various Tribunals",
          "District Courts in NCR",
        ].map((court, i) => (
          <div key={i} className="wcu-trust-item">
            {i > 0 && <div className="wcu-trust-divider" />}
            <span
              style={{
                fontSize: 10,
                color: "rgba(243,238,228,0.45)",
                fontFamily: "sans-serif",
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                textAlign: "center",
              }}
            >
              {court}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
